import { lazy, Suspense } from 'react';
import type { PlumaManagedModalProps } from '@customerio/pluma-components/react';
import type { AutoReloadModalData } from './auto-reload-modal';

// The app shell loads ui.ts on every page, and only the billing pages open this modal, so its code loads
// when it opens rather than with the shell.
const AutoReloadModal = lazy(() =>
  import('./auto-reload-modal').then((module) => ({ default: module.AutoReloadModal })),
);

export function LazyAutoReloadModal(props: PlumaManagedModalProps<AutoReloadModalData>) {
  return (
    <Suspense fallback={null}>
      <AutoReloadModal {...props} />
    </Suspense>
  );
}
